module.exports = __webpack_public_path__ + "img/30982152.7eb50537.png";